<template>
    <div v-if="marcacao">
        <div class="alert" :class="( marcacao && marcacao.ch_estado_marcacao == 'C' ) ? 'alert-danger' : 'alert-primary'" v-if="marcacao">
            <div class="row">
                <div class="col col-12 col-md-8">
                    <h3 v-if="marcacao.ch_estado_marcacao == 'C'">CANCELADA</h3>
                    <div class="lead mb-1">{{ marcacao.procedimento.search }}</div>
                    <div class="d-flex" v-if="( !marcacao.medico.in_numero_conselho || marcacao.medico.in_numero_conselho > 99 ) && marcacao.procedimento.id_especialidade != 2">
                        <i class="fas fa-user-md fa-fw mr-2"></i>
                        {{ marcacao.medico.pessoa && marcacao.medico.pessoa.cadastro ? 
                            ( marcacao.medico.pessoa.cadastro.ch_sexo == 'F' ? 'Dra.' : 'Dr.' ) : 'Dr(a).' }}
                        {{ marcacao.medico.search }}
                    </div>
                    <div class="d-flex">
                        <i class="far fa-calendar-alt py-1 fa-fw mr-2"></i>
                        {{ $util.getFormatDate(marcacao.dt_inicio) }}
                    </div>
                    <div class="d-flex" v-if="marcacao.procedimento.id_especialidade != 2">
                        <i class="fas fa-clock fa-fw py-1 mr-2"></i>
                        <div class="row">
                            <div class="col col-12">
                                {{ marcacao.dt_inicio.substr(11,5) }}
                            </div>
                            <div class="col col-12" v-if="marcacao.link_to_calendar && !marcacao.id_atendimento && marcacao.dt_inicio.substr(0,10) > $util.hoje()">
                                <a :href="marcacao.link_to_calendar" target="_blank" class="btn btn-primary btn-sm my-2">
                                    <i class="fa fa-plus fa-fw mr-2" aria-hidden="true"></i>
                                    Adicionar a Agenda
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <i class="fas fa-map-marker-alt fa-fw p-1 mr-2"></i>
                        <div class="row">
                            <div class="col col-12"  v-if="marcacao.unidade_operacao">
                                {{ marcacao.unidade_operacao.st_nome }}
                            </div>
                            <div class="col col-12 small">
                                {{
                                    marcacao.fl_tele_atendimento 
                                        ? 'Teleatendimento' 
                                        : ( marcacao.unidade_operacao.endereco ? marcacao.unidade_operacao.endereco.exibir : '' )
                                }}
                            </div>
                            <div class="col col-12" v-if="marcacao.local_agenda">
                                {{ marcacao.local_agenda }}
                            </div>
                            <div class="col col-12" v-if="!marcacao.fl_tele_atendimento && marcacao.unidade_operacao.endereco && marcacao.unidade_operacao.endereco.st_map_link">
                                <a :href="marcacao.unidade_operacao.endereco.st_map_link" target="_blank" class="btn btn-primary btn-sm my-2">
                                    <i class="fas fa-map fa-fw mr-2"></i>
                                    Abrir no Google Maps
                                </a>
                            </div>
                        </div>
                    </div>
                    <!-- ( marcacao.unidade.endereco ? marcacao.unidade.endereco.exibir : '' ) -->
                    <div class="d-flex" v-if="!marcacao.fl_adicao_direta || marcacao.id_atendimento">
                        <i class="far fa-credit-card fa-fw py-1 mr-2"></i>
                        {{ marcacao.plano.search }}
                    </div>
                </div>
                <div class="col col-12 col-md-4 text-right d-flex flex-column justify-content-between">
                    <div class="mt-2">
                        <div class="btn-group" role="group">
                            <template v-for="(letra, ilx) in marcacao.codigo_reserva">
                                <button class="btn btn-outline-dark btn-sm" disabled :key="ilx">
                                    {{ letra }}
                                </button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['marcacao'],
}
</script>